import type { DraftInput } from '../../../../shared/drafts';

function createQuestion(level: number): DraftInput['questions'][number] {
  return {
    prompt: `${level}. denge sorusu`, wagonStyle: 'wide', levels: [level], timeLimitSeconds: null,
    choices: [
      { text: 'Doğru cevap', isCorrect: true },
      { text: 'Yanlış cevap', isCorrect: false },
      { text: 'Diğer seçenek', isCorrect: false },
    ],
  };
}

export function createBalanceArenaDraft(): DraftInput {
  return {
    title: 'Yeni Denge Arenası', templateKey: 'balance-arena', levelMode: 'manual',
    maxLevels: 5, trackTime: true, timingMode: 'none',
    questions: Array.from({ length: 5 }, (_, index) => createQuestion(index + 1)),
  };
}

export function resizeBalanceArenaDraft(draft: DraftInput, maxLevels: number): DraftInput {
  const safeLevels = Math.max(5, Math.min(25, Math.trunc(maxLevels)));
  return {
    ...draft, templateKey: 'balance-arena', levelMode: 'manual', maxLevels: safeLevels,
    // Öğretmenin tekrar seçimi soru sayısı değişince korunur.
    trackTime: true, bridgeMode: undefined, timingMode: 'none',
    questions: Array.from({ length: safeLevels }, (_, index) => {
      const level = index + 1;
      return { ...(draft.questions.find((question) => question.levels[0] === level) ?? createQuestion(level)), levels: [level] };
    }),
  };
}
